module.exports={Remove:"Usuń"};